<template>
  <v-row class="mt-0">
    <v-col class="py-0">
      <v-select
        v-bind="{ ...$attrs }"
        @input="v => handleUpdate({ selected: v })"
        :value="selected"
        :label="lgLabel"
        :items="items"
        dense
        outlined
      ></v-select>
    </v-col>
    <v-col class="py-0">
      <v-text-field
        :value="comment"
        @input="v => handleUpdate({ comment: v })"
        counter="1024"
        :label="$t('commons.comment')"
        maxLength="1024"
        dense
        outlined
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
import { max1024 } from "@/utils/validator"

export default {
  name: "SelectorField",
  props: {
    label: { type: String, default: "" },
    items: { type: Array, required: true },
    typename: { type: String },
    values: {
      type: Array,
      default: () => {
        return [{ selected: null, comment: "" }]
      }
    }
  },
  computed: {
    // lgLabel() {
    //   return `${this.label} - ${this.typename}`.toUpperCase()
    // },
    lgLabel() {
      return `${this.label}`.toUpperCase()
    },
    selected: {
      get() {
        return this.values[0].selected
      }
    },
    comment: {
      get() {
        return this.values[0].comment
      }
    }
  },
  data() {
    return {
      rules: [max1024]
    }
  },
  methods: {
    handleUpdate(updateObj) {
      const oldObj = { id: 0, selected: this.selected, comment: this.comment }
      const newValue = [{ ...oldObj, ...updateObj }]
      this.$emit("input", newValue)
    }
  }
}
</script>
